import { render, staticRenderFns } from "./NavigationDrawerItems.vue?vue&type=template&id=01b0aaf9&scoped=true&"
import script from "./NavigationDrawerItems.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerItems.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDrawerItems.vue?vue&type=style&index=0&id=01b0aaf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0aaf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSubheader})
